let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZPgJ")).then(() => parcelRequire('foxjO'));